import styles from "./auctionLots.module.scss";
import React from "react";
export default function ListPagination(props) {
    var _a, _b, _c;
    return (React.createElement(React.Fragment, null,
        React.createElement("a", { "data-disabled": props.firstPageDisabled, className: styles.pageControlBtn, onClick: props.loadFirstPage }, (_a = props.strings) === null || _a === void 0 ? void 0 : _a.first),
        React.createElement("a", { "data-disabled": props.previousPageDisabled, className: styles.pageControlBtn, onClick: props.loadPreviousPage }, (_b = props.strings) === null || _b === void 0 ? void 0 : _b.previous),
        React.createElement("span", { className: styles.pageControlBtn },
            props.currentPage,
            "/",
            props.totalPages),
        React.createElement("a", { "data-disabled": props.nextPageDisabled, className: styles.pageControlBtn, onClick: props.loadNextPage }, (_c = props.strings) === null || _c === void 0 ? void 0 : _c.next)));
}
